
import CloseIcon from '@mui/icons-material/Close';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import DashboardIcon from '@mui/icons-material/Dashboard';


import LightModeIcon from '@mui/icons-material/LightMode';

import MenuIcon from '@mui/icons-material/Menu';

import PersonIcon from '@mui/icons-material/Person';


import TableChartIcon from '@mui/icons-material/TableChart';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { ColorContext } from '../../ColorContext/darkContext';

// import sass file
import './navbar.scss';

function Navbar() {
    const [toggle, setToggle] = useState(false);
    // color state management using react context
    const { darkMode, dispatch } = useContext(ColorContext);

    const handleToggle = () => {
        setToggle(!toggle);
    };

    return (
        <div className="navbarr">
            <div className="navbar_main">
                <div className="menu_logo max-sm:block hidden">
                    {toggle ? (
                        <CloseIcon className="menu_icon" onClick={handleToggle} />
                    ) : (
                        <MenuIcon className="menu_icon" onClick={handleToggle} />
                    )}
                </div>


                <div className="item_lists">
                    {/* <div className="item">
                        {!darkMode ? (
                            <DarkModeIcon
                                className="item_icon"
                                onClick={() => dispatch({ type: 'TOGGLE' })}
                            />
                        ) : (
                            <LightModeIcon
                                className="item_icon white"
                                onClick={() => dispatch({ type: 'TOGGLE' })}
                            />
                        )}
                    </div> */}



                </div>
            </div>

            <div className="res_navbar">
                {toggle && (
                    <div className="res_nav_menu">
                        <div className="res_nav_menuu">
                            <div className="links">
                                <ul>

                                    <Link to="/" style={{ textDecoration: 'none' }}>
                                        <li>
                                            <DashboardIcon className="icon" /> 
                                            <p className='ml-8'>Dashboard</p>
                                        </li>
                                    </Link>

                                   
                                    <Link to="/admin/dashboard/users" style={{ textDecoration: 'none' }}>
                                        <li>
                                            <PersonIcon className="icon" />
                                            <p className='ml-8'>Users</p>
                                        </li>
                                    </Link>

                                    <Link to="/admin/dashboard/products" style={{ textDecoration: 'none' }}>
                                        <li>
                                            <TableChartIcon className="icon" />
                                            <p className='ml-8'>Product</p>
                                        </li>
                                    </Link>

                                    <Link to="/admin/dashboard/addnewproducts" style={{ textDecoration: 'none' }}>
                                        <li>
                                        <PersonIcon className="icon" />
                                            <p className='ml-8'>Add New Admin</p>
                                        </li>
                                    </Link>



                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Navbar;
